<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="template-font-add-form-modal-label">
                {{ $root.text(
                    'Add {template} font',
                    {
                        template: $root.text($root.contents.template_title, null, false, 'template_title')
                    },
                    true
                ) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-if="updated" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated"></div>
                </div>
            </div>
            <div v-else>
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <form v-if="$root.hasPermission('templates_manage_fonts')" v-on:submit.prevent="onSubmit()">
                    <div class="form-group">
                        <label for="template-font-name" id="template-font-name-label" class="mandatory-label">
                            {{ $root.text('Name', null, true) }} *
                        </label>
                        <input
                            v-model="template_font.name"
                            type="text"
                            id="template-font-name"
                            class="form-control mandatory-field"
                            :readonly="updating"
                            v-on:keyup="$root.unHighlightErrors('template-font-name')"
                            v-on:change="$root.unHighlightErrors('template-font-name')"
                        >
                    </div>
                </form>
            </div>
        </div>
        <div v-if="($root.hasPermission('templates_manage_fonts') && !updated)" class="modal-footer">
            <span v-if="!updating">
                <button :key="'add-button'" type="button" class="btn btn-primary" @click="onSubmit()">
                    <i class="far fa-check mr-1"></i> {{ $root.text('Add', null, true) }}
                </button>
            </span>
            <span v-else>
                <button :key="'adding-button'" type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Add', null, true) }}</span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                errors: false,
                updating: false,
                updated: false,
                template_font: {}
            }
        },
        mounted () {
            //
        },
        methods: {
            resetForm: function () {
                if (!this.$root.hasPermission('templates_manage_fonts')) {
                    this.errors = this.$root.text('Sorry, you do not have access to this function.', null, true);

                    return false;
                }
                this.errors = false;
                this.updating = false;
                this.updated = false;
                this.template_font = {};
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                setTimeout(function () {
                    $('#template-font-name').focus();
                }, 500);
            },
            onSubmit: function () {
                this.errors = false;
                this.updating = true;
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                /**
                 * Send request to API.
                 */
                const data = this.template_font;
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/template-font';
                var vm = this;

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.updated = 'Success';
                    if (response.data.message) {
                        vm.updated = response.data.message;
                        vm.$parent.getFonts();
                    }

                    setTimeout(function () {
                        $('#template-font-add-form-modal').modal('hide');
                    }, 2000);
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // Missing/lost API token - close modal and logout user.
                            $('#template-font-add-form-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            if (typeof error.response.data.error === 'string') {
                                vm.errors = error.response.data.error;
                            } else if (typeof error.response.data.error === 'object') {
                                vm.errors = '';
                                for (const [key, value] of Object.entries(error.response.data.error)) {
                                    vm.errors += value.join('<br>') + '<br>';
                                    $('#template-font-' + key + '-label').addClass('text-danger');
                                    $('#template-font-' + key).addClass('field-error');
                                }
                            }
                        }
                    }
                })
                .finally(() =>
                    vm.updating = false
                );
            }
        }
    }
</script>
